import { render, staticRenderFns } from "./ProductStatusFomation.vue?vue&type=template&id=83841b86&scoped=true"
import script from "./ProductStatusFomation.vue?vue&type=script&lang=js"
export * from "./ProductStatusFomation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83841b86",
  null
  
)

export default component.exports